export default {
  fi: {
    PartnerEditScene: {
      editInformation: 'Muokkaa yrityksen tietoja',
    },
  },
};
